




import { Component, Mixins, Watch } from 'vue-property-decorator'
import { LibraryMixin } from '@/mixins'

@Component({})
export default class Features extends Mixins(LibraryMixin) {
  async redirectIfNoLibrary() {
    if (this.library === null) {
      await this.$router.push({
        name: 'dashboard'
      })
    }
  }

  async created() {
    await this.redirectIfNoLibrary()
  }

  @Watch('library')
  async fetchLibrary() {
    await this.redirectIfNoLibrary()
  }
}
